




































































import { Component, Vue } from "vue-property-decorator"
import PublicTable1 from "@/components/PublicTable/PublicTable1.vue"
import PublicTableView from "@/components/PublicTable/PublicTableView"
import { ICol } from "@/components/PublicTable/PublicTable"
import { formatDate, isEmpty, setDateToStart } from "../../utils/utils"
import config from '@/config'
import api from "../../api"
import Echarts from "@/components/Echarts/Echarts.vue"
import { UserModule } from "../../store/modules/user"
import echarts from "echarts"
import { log } from "console"
import md5 from 'js-md5'

import Axios from "axios"
@Component({
  components: {
    PublicTable1,
    Echarts,
  },
})
export default class DevList extends PublicTableView {
  protected columns: ICol[] = [
    { label: "设备ID", prop: "devId" },
    { label: "设备名称", prop: "devName" },
    { label: "网络名称", prop: "netName", sortable: true },
    { label: "当前版本号", prop: "devNowType" },
    { label: "最新版本号", prop: "show", type: "custom" },
    { label: "电量", prop: "power", sortable: true },
    { label: "电量曲线", prop: "content", type: "custom" },
  ]
  protected search = ""
  protected noData = ""
  protected option = ""
  protected queryParams = {
    orgId: UserModule.orgInfo.orgId,
    dialogshow: false,
    devId: "",
  }
  public mounted() {
    this.onQuery(1)
  }
  protected queryMethod = api.getOrgDevVersion

  protected processData(data: any) {
    // console.log('-------' + JSON.stringify(data))
    return data
  }
  private getDevLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult = logs.map((item: any) => [
      item.time,
      item.ope + baseVal,
      item,
    ])
    if (logs[0] && new Date(logs[0].time) > minTime) {
      let open = Number(logs[0].ope)
      logResult.unshift([minTime, open + baseVal, logs[0]])
    }
    if (
      logs[logs.length - 1] &&
      new Date(logs[logs.length - 1].time) < maxTime
    ) {
      let open = logs[logs.length - 1].ope
      /** 如果最大值大于今天的日期，只接受当前时间 */
      if (maxTime > Date.now()) {
        logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
      } else {
        logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
      }
    }
    console.log(logResult)
    for (let i = 0; i < logResult.length; i++) {
      if (i == 0) {
        if (logResult[i][2].opeType == "power") {
          logResult[i][2].opeType = "people"
          logResult[i][2].ope = 0
          if (
            logs[logs.length - 1] &&
            new Date(logs[logs.length - 1].time) < maxTime
          ) {
            let open = logs[logs.length - 1].ope
            /** 如果最大值大于今天的日期，只接受当前时间 */
            if (maxTime > Date.now()) {
              logResult.push([
                Date.now(),
                open + baseVal,
                logs[logs.length - 1],
              ])
            } else {
              logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
            }
          }

          // console.log(logResult[i]);
        }
      }
      if (logResult[i][2].opeType == "nativepeople") {
        // console.log(logResult);
        if (i == 0) {
          logResult[i][1] = logResult[i + 1][1]
        } else {
          logResult[i][1] = logResult[i - 1][1]
        }
      }
    }
    //  for(let i=0;i<logResult.length;i++){
    //   if(logResult[i][2].opeType=='power'){
    //     logResult.splice(i--,1)
    //     // console.log(logResult[i]);

    //   }
    //  }
    let x = logResult.length
    while (x--) {
      if (logResult[x][2].opeType == "power") {
        logResult.splice(x, 1)
      }
    }
    console.log(logResult)

    return logResult
  }
  private getDevData(devId: any) {
    // let data=[{time:"2022-11-02",power:2000},{time:"2022-11-08",power:1800},{time:"2022-11-15",power:1100}]
    api
      .getDevPowerList({ devId })
      .then((data) => {
        console.log(data)

        // api.getNetDevBehavior({ date, netId: 'a08f3262-bd4f-4daa-a4b5-c029699eebdc' }).then((data) => {
        const { people = [], devs = [] }: { people: any[]; devs: any[] } =
          data || {}
        // this.noData = !people.length && !devs.length
        this.noData = !data.length
        // console.log('单元' + JSON.stringify(devs))
        if (this.noData) return

        this.option = {
          title: {
            textStyle: {
              color: "#333",
              fontStyle: "normal",
              fontWeight: "200",
              fontFamily: "sans-serif",
              fontSize: 15,
            },
            text: this.queryParamssz.devname + "电量记录曲线图",
            x: "center",
            y: "bottom",
            padding: [100, 0, 0, 0],
          },
          tooltip: {
            trigger: "axis",
            // formatter: function(params: any[]) {
            //   let result = ''
            //   result += params.reduceRight((prev, curr, index) => {
            //     if (index === params.length - 1) {
            //       prev += `${formatDate(curr.axisValue)}<br>`
            //     }
            //     const r = prev += `${curr.marker}${curr.seriesName} ${UnitControlTypeMap.get(curr.value[2].opeType) || ''}${curr.value[1] || '关'}<br>`
            //     return r
            //   }, result)
            //   return result
            // },
          },
          // legend: {
          //   data: devss.map((item) => item.devName).reverse(),
          //   itemHeight: 10, // 改变圆圈大小
          //   icon: 'circle',
          //   textStyle: {
          //     fontSize: 14,
          //   },
          // },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "10%",
            containLabel: true,
          },
          // toolbox: {
          //   feature: {
          //     dataZoom: {
          //       yAxisIndex: 'none',
          //     },
          //     restore: {},
          //     saveAsImage: {
          //       name: '单元分析',
          //     },
          //   },
          // },
          dataZoom: [
            {
              type: "inside",
              filterMode: "none",
              throttle: 50,
            },
          ],
          xAxis: {
            type: "category",
            data: data.map((item) => item.date),
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: data.map((item) => item.power),
              type: "line",
              smooth: true,
            },
          ],
        }
      })
      .catch(() => {
        // console.log(123);
        this.$nextTick(() => {
          this.$message.error("当前设备无电量记录")

          this.queryParams.dialogshow = false
        })
      })
  }
  private getPeopleData(peoples: any[]) {
    if (!peoples || !peoples.length) return []
    const lastIndex = peoples.length - 1
    if (peoples[lastIndex].people === 1) {
      peoples.push({ time: Date.now(), people: 0 })
    }
    return peoples.map((item: any) => [item.time, item.people, item])
  }
  private tiset(name, devId) {
    // console.log(123);
    this.queryParams.dialogshow = true
    this.queryParamssz.devId = devId
    this.queryParamssz.devname = name
  }
  private queryParamssz = {
    date: formatDate(new Date(), "YYYY-MM-DD"),
    dateTime: formatDate(new Date(), "YYYY-MM-DD"),
    devId: "",
    devname: "",
  }
  private nowitem = {}
  private open() {
    this.$nextTick(() => {
      // console.log(13);

      const { date = "", region = [] } = this.queryParamssz
      this.getDevData(this.queryParamssz.devId)
    })
  }
  private orgExcel() {
      const timeStamp = Date.now()
    console.log(UserModule.orgInfo.orgId)
    let params = {
      orgId: UserModule.orgInfo.orgId,
    }

    this.$confirm("是否需要导出设备所有关系?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        fetch(config.apiBaseUrl+"/V1/Org/orgExcel?orgId="+UserModule.orgInfo.orgId, {
  method: 'GET',
  responseType: 'blob',
  headers: {
    

   

     'Name': UserModule.name,
        'Token': UserModule.token,
        'Time-Stamp': timeStamp,
        'platform': 'manageWeb',
        'Sign': md5(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`),
  }
})
.then(response =>response.blob()
)
.then(data => {
  console.log(data);
  
  let downloadFilename = '设备关系列表.xls'//设置导出的文件名
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //兼容ie浏览器  
    window.navigator.msSaveOrOpenBlob(data, downloadFilename)
  } else {
    //谷歌,火狐等浏览器
    let url = window.URL.createObjectURL(data)
    let downloadElement = document.createElement("a")
    downloadElement.style.display = "none"
    downloadElement.href = url
    downloadElement.charset = 'UTF-8'
    downloadElement.download = downloadFilename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(url)
  }
})
.catch(error => console.error('Error:', error));





     
    
      })
      .catch(() => {})
  }
  private orgmxExcel() {
      const timeStamp = Date.now()
    console.log(UserModule.orgInfo.orgId)
    let params = {
      orgId: UserModule.orgInfo.orgId,
    }

    this.$confirm("是否需要导出设备明细?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        fetch(config.apiBaseUrl+"/V1/Org/devExcel?orgId="+UserModule.orgInfo.orgId, {
  method: 'GET',
  responseType: 'blob',
  headers: {
    

   

     'Name': UserModule.name,
        'Token': UserModule.token,
        'Time-Stamp': timeStamp,
        'platform': 'manageWeb',
        'Sign': md5(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`),
  }
})
.then(response =>response.blob()
)
.then(data => {
  console.log(data);
  
  let downloadFilename = '设备明细.xls'//设置导出的文件名
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //兼容ie浏览器  
    window.navigator.msSaveOrOpenBlob(data, downloadFilename)
  } else {
    //谷歌,火狐等浏览器
    let url = window.URL.createObjectURL(data)
    let downloadElement = document.createElement("a")
    downloadElement.style.display = "none"
    downloadElement.href = url
    downloadElement.charset = 'UTF-8'
    downloadElement.download = downloadFilename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(url)
  }
})
.catch(error => console.error('Error:', error));





        // window.location.href = "https://api.szh1tech.com/V1/Org/orgExcel?orgId="+UserModule.orgInfo.orgId
      //   api.orgExcel({orgId:UserModule.orgInfo.orgId}).then(response=>{
      //   // Axios({
      //   //   method: "get",
      //   //   url: "/V1/Org/orgExcel",
      //   //   baseURL: "http://47.115.57.107:8087/",
      //   //   params: params,
      //   //   // responseType: "blob", //定义接口响应的格式,很重要
      //   // }).then((response) => {
      //     console.log(response);
          
      //     let blob = new Blob([response], { type:'application/octet-stream' }) //response.data为后端传的流文件
      //     // console.log(bolb)
          
      //     let downloadFilename ='关系列表.xls'//设置导出的文件名
      //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //       //兼容ie浏览器
      //       window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
      //     } else {
      //       //谷歌,火狐等浏览器
      //       let url = window.URL.createObjectURL(blob,{type : 'application/vnd.ms-excel;charset=utf-8'})
      //       let downloadElement = document.createElement("a")
      //       downloadElement.style.display = "none"
      //       downloadElement.href = url
      //       downloadElement.charset = 'UTF-8'
      //       downloadElement.download = downloadFilename
      //       document.body.appendChild(downloadElement)
      //       downloadElement.click()
      //       document.body.removeChild(downloadElement)
      //       window.URL.revokeObjectURL(url)
      //     }
      //   })
      })
      .catch(() => {})
  }




  private deleteUser(row: any) {
    this.$confirm("删除此用户, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        api.deleteUser({ name: row.name }).then(() => {
          this.$message.success("删除成功")
          this.onQuery({ pageNum: 1, isUseCache: false })
        })
      })
      .catch(() => {})
  }
}
